var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{attrs:{"offset-y":"","rounded":"lg","content-class":"elevation-2"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({staticClass:"pa-1"},'v-icon',attrs,false),on),[_vm._v("\n      "+_vm._s(_vm.icon)+"\n    ")])]}}])},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }